export const BULK_CREATE_GET_TEAMS_REQUEST = 'BULK_CREATE_GET_TEAMS_REQUEST';
export const BULK_CREATE_GET_TEAMS_SUCCESS = 'BULK_CREATE_GET_TEAMS_SUCCESS';
